<template>
    <FooterMobile v-if="!pageMode && isLoggedIn && (isTgApp || isPWA)" :menu="menu" :loading="loading"/>
    <FooterDesktop v-if="!pageMode && !isTgApp && !isPWA" :menu="menu" :loading="loading"/>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import FooterDesktop from '@/components/sides/footer/Desktop.vue'
import FooterMobile from '@/components/sides/footer/Mobile.vue'

export default {
    name: 'footer',
    props: ['menu', 'loading'],
    data() {
        return {}
    },
    components: {
        FooterDesktop,
        FooterMobile
    },
    computed: {
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        pageMode: function () {
            try { return this.$route.meta.pageMode } 
            catch { return false }
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>